import { FileType } from './enums';

export const setPageNumber = (page: number, limit: number) => {
  return `?currentPage=${page}&pageLimit=${limit}`;
};

export const getParameterByName = (name: string, url: string) => {
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const downloadFile = (data: any, type: FileType, fileName: string) => {
  const blob = new Blob([data], { type });

  // Create a temporary link element to trigger download
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the object URL
  URL.revokeObjectURL(link.href);
};
